import CompanyQuoteFinancials from './CompanyQuoteFinancials'
// Uncomment the below to migrate to stateful component
// import CompanyQuoteFinancialsContainer from './CompanyQuoteFinancialsContainer'

export { CompanyQuoteFinancials }
export default CompanyQuoteFinancials
// Uncomment the below to migrate to stateful component
// export { CompanyQuoteFinancialsContainer }
// export default { CompanyQuoteFinancialsContainer }
